<template>
  <div id="main_left_menu">
    <div>
      <a>
        <img width="100" src="@/assets/images/logo.svg" />
      </a>
    </div>
    <UserProfilDetails />
    <div id="main_left_menu_container">
      <ul>
        <li
          v-for="(menu, index) in $store.state.configs.menus"
          :key="index"
          class=""
        >
          <i :class="menu.icon"></i>
          <b-link v-if="!menu.extern" :to="menu.path">{{ menu.title }}</b-link>
          <a v-if="menu.extern" target="_blank" :href="menu.path">{{menu.title}}</a>
        </li>
      </ul>
    </div>
    <div id="main_left_menu_bottom">
     <div>
      <a @click.prevent="logout()" href="#">
          <i class="mdi mdi-logout"></i>
          <span class="link">Déconnexion</span>
      </a>
     </div>
    </div>

    <MenuPattern />
  </div>
</template>

<script>
import MenuPattern from "./MenuPattern";
import UserProfilDetails from "./UserProfilDetails";

export default {
  components: { MenuPattern, UserProfilDetails },
  name: "MainMenu"
};
</script>
<style scoped lang="css">
#main_left_menu {
  padding: 60px 30px 30px 30px;
  overflow: hidden;
}


#main_left_menu_container>ul{
    list-style: none;
    padding: 0;
    margin: 0;
}

#main_left_menu_container>ul li{
    position: relative;
    padding-left: 35px;
    margin-bottom: 15px;
}

#main_left_menu_container>ul li i{
    position: absolute;
    font-size: 22px;
    top: 0;
    left: 0;
}

#main_left_menu_container>ul li a{
    position: relative;
    top: 0px;
    color: #000;
    text-decoration: none;
}

#main_left_menu_container>ul li a.router-link-exact-active{
  font-weight: bold !important;
}

#main_left_menu_container>ul li a:hover{
    text-decoration: none;
}

#main_left_menu_bottom{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0 30px;
  font-weight: bold !important;
}

#main_left_menu_bottom>div{
  padding: 15px 0;
  border-top: 2px solid #d3ad13;
}

#main_left_menu_bottom a{
  color:#b81e50;
  position: relative;
  transition: .3s;
}

#main_left_menu_bottom a:hover{
  color:#f31b61;
  transition: .3s;
}

#main_left_menu_bottom i{
  font-size: 22px;
  margin-right: 5px;
}

#main_left_menu_bottom a span{
  position: relative;
  top: -2px;
}
</style>
